import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_LINK } from "../lib/data";
type Props = {
  label?: string;
  variant?: "scroll" | "checkout";
  className?: string;
};
export function scrollToBuy() {
  const el = document.getElementById("compra");
  if (el) el.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
}
export function BuyButton({
  label = "Quiero resolver mis clases de fútbol",
  variant = "scroll",
  className = ""
}: Props) {
  const handleClick = () => {
    if (variant === "checkout") {
      window.location.href = CHECKOUT_LINK;
    } else {
      scrollToBuy();
    }
  };
  return <button type="button" onClick={handleClick} className={`group w-full rounded-xl bg-[#8bc34a] px-5 py-4 text-center text-base font-extrabold uppercase tracking-wide text-[#0f2c4a] shadow-lg shadow-[#8bc34a]/30 transition-transform active:scale-[0.98] hover:bg-[#7cb342] ${className}`} data-id="element-49" data-mp="3c7htdy2ane47">
      <span className="inline-flex items-center justify-center gap-2" data-id="element-50" data-mp="3r66htrl681i">
        {label}
        <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-51" data-mp="17baatt4il9n3" />
      </span>
    </button>;
}